import {Component, ElementRef, OnInit, ViewChild, AfterViewInit, OnDestroy} from '@angular/core';
import { licence } from '../../models/licence';
import { LicenseService } from '../../Services/license.service';
import { GlobalService } from '../../Services/global.service';
import { ActivatedRoute,Router} from '@angular/router';
import * as moment from 'moment';
import {Configuration} from "../../config/config";
import {debounceTime, distinctUntilChanged, map} from "rxjs/operators";
import {Observable} from "rxjs/Rx";
import {TranslateService} from '@ngx-translate/core';
import {NgForm} from '@angular/forms';
import * as CryptoJS from 'crypto-js';
declare let $;
declare let paypal: any;
@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css'],
  providers : [LicenseService]
})

export class SubscriptionComponent implements OnInit, OnDestroy {

  @ViewChild('subscriptionForm')
  private subscriptionForm: NgForm;
  @ViewChild('subscriptionFormL') subscriptionFormL : NgForm;
  passwordType: boolean = false;

  constructor(private LicenseService : LicenseService, private globalServices : GlobalService, private router : Router,private route: ActivatedRoute, private translate : TranslateService) { }
  selectedLicensesList :any[] = [];
  selectedLicenseData : any;
  validationMsg : string = "";
  couponValidationMsg : string = "";
  subscribeValidationMsg : string = "";
  subStatusCode : string = "";
  zeroLicenseCode : string = "";
  certificateSubscribe : string = "";
  communityMsg: string;
  words = [] ;
  coupon_code;
  TotalPrice = 0;
  discountPrice : number = 0;
  InvalidCoupon = false;
  isIndividualLearner = true;
  subtotal = 0;
  valArr = [];
  paymentBy;
  Payments ;
  appliedCoupons = 0;
  coupon_id;
  subscribeLicIdList = [];
  communityActivation: boolean;
  showCouponCode: boolean;
  model;

  showCommunityList: boolean;
  allCommunityList = [];
  communityID;
  userID;
  role;
  courseList;
  certificatesList;
  journeysList;
  noCourseFound;
  noCertificatesFound;
  noJourneysFound;
  viewTitle : string;
  contentTitle : string;
  subscribeTitle : string;
  detailsTitle : string;
  unsubTitle : string;
  availableLicSearchTitle : string;
  subscribedUsersList;
  subscribedCommunityList;
  subscribed_by: string;
  tDeleteStatusCode: string;
  password;
  selected_courses = [];
  selected_certificates = [];
  hideTabs: boolean = false;
  getRole;
  hideAvlLictable = true;
  hideSubLictable = false;
  couponDetails;
  isOneFreeLicNotSelected : boolean = false;
  subscriptionFor : string = '';
  selectedUserList: Array<any> = [];
  selectedAllUsers: any;
  licenseUserId: any;
  validationMsgList: string;
  singleLicense: any = '';
  agreement: any;
  tourTranslateData: any = [];
  screenWidth : number = 1366;
  screenHeight : number;

  ngOnDestroy() {
    $('body').removeAttr('style');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }
  
  ngOnInit() {
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;

    window.addEventListener("orientationchange", () => {
      // Announce the new orientation number
      if (window.orientation == 90) {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      } else {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      }
    });
    let lang_name = localStorage.getItem('defaultLang');
    this.translate.use(lang_name);
    localStorage.setItem('currentScreen', 'LICENSE_SUBSCRIPTION');
    this.globalServices.getTranslationTour();
    this.getRole = localStorage.getItem('userRole');
    if(this.getRole == 'Learner' || this.getRole == 'Manager'){
      $('.learnerCommonFooter').css('display','block');
      $(document).ready(function() {
        $("#disablePrevent").on("contextmenu",function(){
          return false;
        });
      });
    }

    let SECURETOKEN = this.route.snapshot.queryParams["SECURETOKEN"];

    if(this.route.snapshot.queryParams && SECURETOKEN){

      if(localStorage.getItem('userRole') == 'Alignor Admin'){
        if(localStorage.getItem('selectedCommunityName')){
          this.model = JSON.parse(localStorage.getItem('selectedCommunityName'));
          this.loadCommunities();
          localStorage.removeItem('selectedCommunityName');
        } else {
          this.LicenseService.cleareTable().subscribe(res => {
            this.showData();
          });
        }

      } else {
        this.LicenseService.cleareTable().subscribe(res => {
          this.showData();
        });
      }

      localStorage.removeItem('all_subscription_arr');
      this.valArr = [];
      this.router.navigate(['/dashboard/Licences/subscribe']);
    }

    if(localStorage.getItem('activationStatus') == "Inactive"){
      this.communityActivation = true;
    }else {
      this.communityActivation = false;
    }
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if(theUser.user.role == "Learner" || theUser.user.role == "Manager"){
      this.isIndividualLearner = true;
      this.subscribed_by = "Learner";
    } else {
      this.isIndividualLearner = false;
      this.subscribed_by = "Admin";
    }
    this.role = theUser.user.role;
    if(this.role == "Learner" || this.role == "Manager" || this.role == "Community Admin"){
     this.Payments = [{
        'name': 'Paypal'
      }];
    }else {
      this.Payments = [{
        'name': 'Direct'
      },{
        'name': 'Paypal'
      }];
    }
    if(this.role == "Alignor Admin"){
      this.showCommunityList = true;
      this.LicenseService.getAllCommunities().subscribe(res => {
        this.allCommunityList = res.data;
        const subscribeTable = $('#subscribedLicenceTable').DataTable();
        subscribeTable.destroy();
        $('#subscribedLicenceTable').DataTable({
          responsive: true,
          "autoWidth" : false,
          "searching": false,
          "ordering": false,
          "sorting": false
        });
        const availableTable = $('#availableLicenceTable').DataTable();
        availableTable.destroy();
        $('#availableLicenceTable').DataTable({
          responsive: true,
          "autoWidth" : false,
          "searching": false,
          "ordering": false,
          "sorting": false
        });
      });
    }else {
      this.hideTabs = true;
      this.validationMsg = "";
      this.communityID = theUser.user.community_id;
      this.showCommunityList = false;
      this.userID = theUser.user.userid;
      this.LicenseService.cleareTable().subscribe(res => {
        const subscribeTable = $('#subscribedLicenceTable').DataTable();
        subscribeTable.destroy();
        $('#subscribedLicenceTable').DataTable({
          responsive: true,
          "autoWidth" : false,
          "searching": false,
          "ordering": false,
          "sorting": false
        });
        const availableTable = $('#availableLicenceTable').DataTable();
        availableTable.destroy();
        $('#availableLicenceTable').DataTable({
          responsive: true,
          "autoWidth" : false,
          "searching": false,
          "ordering": false,
          "sorting": false
        });
        this.showData();
      });
    }
    this.translate.get('BUTTON_TITLE.VIEW').subscribe(label => this.viewTitle = label);
    this.translate.get('BUTTON_TITLE.CONTENTS').subscribe(label => this.contentTitle = label);
    this.translate.get('BUTTON_TITLE.SUBSCRIBE').subscribe(label => this.subscribeTitle = label);
    this.translate.get('SUBSCRIPTION_FORM.COUPON_DETAILS.TITLE').subscribe(label => this.detailsTitle = label);
    this.translate.get('SUBSCRIPTION_FORM.UNSUB_LICENSE').subscribe(label => this.unsubTitle = label);
    this.translate.get('DATA_TABLE_SEARCH_PLACEHOLDER.LICENSE').subscribe(label => this.availableLicSearchTitle = label);
    this.loadTranslatedTexts();
  }

  changePasswordType() {
    this.passwordType = !this.passwordType
  }

  loadTranslatedTexts(){
    this.translate.get(['LICENSE.LICENCE_NAME','LICENSE.TERM','LICENSE.PRICE','LICENSE.COUPON_CODE','LICENSE.LICENCE_TYPE','LICENSE.NO_OF_LICENSE','LICENSE.SUBSCRIBE_DATE','LICENSE.EXPIRY_DATE','LICENSE.ACTION','LICENSE.SELECT','LICENSE.DATE', 'SUBSCRIPTION_FORM.AMOUNT_PAID', 'SUBSCRIPTION_FORM.TRANSACTION_SUCCESS', 'SUBSCRIPTION_FORM.TRANSACTION_ID', 'SUBSCRIPTION_FORM.SUB_LICENSE']).subscribe(label =>{
      console.log("-----------------Subscription Label-------------------");
      console.log(label);
      this.tourTranslateData = label;
      if(!this.tourTranslateData){
        this.loadTranslatedTexts();
      }
    });
  }

  loadCommunities(){
    if(this.model != undefined && this.model != ""){
      if(this.model.comm_name == undefined){
        this.LicenseService.getCommunityByName(this.model).subscribe(res => {
          if(res.data == null){
            this.communityMsg = "101";
          }else {

            this.communityMsg = "";
            this.communityID = res.data.comm_id;
            this.hideTabs = true;
            this.getAllCommunityUsers();
          }
        });
      }else {
        this.LicenseService.getCommunityByName(this.model.comm_name).subscribe(res => {
          if(res.data == null){
            this.communityMsg = "101";
          }else {
            this.communityMsg = "";
            this.communityID = res.data.comm_id;
            this.hideTabs = true;
            this.getAllCommunityUsers();
          }
        });
      }
    }else {
      this.communityMsg = "102";
      this.communityID = undefined;
      this.hideTabs = false;
    }
  }
  selectedItem = (input) => {
    this.communityID = input.comm_id;
    return input.comm_name;
  }
  formatter = (result) => {
    return result.comm_name;
  }
  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.allCommunityList.filter(v => v.comm_name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  );

  showData(){
    $("#preloader").css('display','block');
    this.screenWidth = screen.width || window.screen.width;
    const that = this;
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.validationMsg = "";
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    this.role = theUser.user.role;
    let currentLang = this.globalServices.getTableLanguage();
    let styleTextLeft = this.screenWidth < 1000 ? "style='text-align:left !important'" : "";
    let alignContentLeft = this.screenWidth < 1000 ? "style='left:0px !important'" : "";
    if(this.role == "Learner" || this.role == "Manager"){// && theUser.user.community_id == "global"
      let table = $('#subscribedLicenceTable').DataTable();
      table.destroy();
      $("#subscribedLicenceTable").DataTable({
        responsive: true,
        "autoWidth" : false,
         "serverSide": true,
        'initComplete': ()=> {
          $("#preloader").css('display','none');
        },
         "ajax": {
         "url": Configuration.ServerWithApiUrl+'/subscribedLicByUserName/'+this.userID+'/'+this.communityID,
         "type": 'POST',
           "headers" : {
             "Authorization" : currentUser.token.toString()
           },
           "error" : function (xhr, error, thrown) {
             if(xhr.responseJSON && xhr.responseJSON.statusCode) {
               if (xhr.responseJSON.statusCode === 'exp-token' || xhr.responseJSON.statusCode == 'no-token') {
                 that.router.navigate(['/login']);
               }
             }
           }
         },
        "language" : {
          url :  currentLang,
          searchPlaceholder : this.availableLicSearchTitle,
          sSearch : ""
        },
        "columns":[
          {"data": "licence_name"},
          {"data": "term"},
          {"data": {
            "price": "price",
            "paid_status": "paid_status"
          }},
          {"data": "coupon_code"},
          {"data": "licence_type"},
          {"data": "no_of_license"},
          {"data": "subscribeDate"},
          {"data": "expiry_date"},
          {"data": "licence_id"}
        ],
        "order": [5, 'desc'],
        "columnDefs":[
          {
            "targets": 1,
            "render": function (data) {
              if(data.length > 0){
                return data[1]+' '+data[0];
              }else {
                return "NA";
              }
            }
          },{
            "targets": 2,
            "render": function (data) {
              if(data.paid_status == 'paid'){
                return '$ ' + data.price;
              }else {
                return "NA";
              }
            }
          },{
            "targets": 3,
            "render": function (data) {
              if(data){
                return data;
              }else {
                return "NA";
              }
            }
          },{
            "targets": 5,
            "render": function (data) {
              if(data){
                return data;
              }else {
                return "NA";
              }
            }
          },
          {
            "targets": 6,
            "render": (data)=> {
              if(data){
                return this.getCreationDate(data);
              }else {
                return "NA";
              }
            }
          },{
            "targets": 7,
            "render": (data)=> {
              if(data){
                return this.getCreationDate(data);
              }else {
                return "NA";
              }
            }
          }, {
            "targets": 4,
            "render": function (data) {
              if(data == "term_License"){
                return "Term";
              } else if(data == "one_time_purchase"){
                return "One Time Purchase";
              } else if(data == "journey_License"){
                return "Journey";
              } else {
                return "Bundle";
              }
            }
          },
          {
            "targets": 8,
            "render":  (data) =>{
              if(data == 'global'){
                return '';
              }else {
                return '<div class="demo" '+ styleTextLeft +'>\n' +
                  '    <div class="wrapper">\n' +
                  '        <div class="content"' + alignContentLeft + '>\n' +
                  '            <ul>\n' +
                  '                <li id="Content">'+this.contentTitle+'</li>\n' +
                  '                <li id="Details">'+this.detailsTitle+'</li>\n' +
                  '            </ul>\n' +
                  '        </div>\n' +
                  '        <div class="parent"><i class="fa overflow-icon" ></i></div>\n' +
                  '    </div>\n' +
                  '</div>';
              }
            }
          },
          { 'width': '30%', 'targets': 0 },
          { 'width': '10%', 'targets': 1 },
          { 'width': '5%', 'targets': 2 },
          { 'width': '10%', 'targets': 3 },
          { 'width': '10%', 'targets': 4 },
          { 'width': '5%', 'targets': 5 },
          { 'width': '10%', 'targets': 6 },
          { 'width': '10%', 'targets': 7 },
          { 'width': '10%', 'targets': 8 }
        ]
      });
      $('#subscribedLicenceTable tbody').on('click', 'li', (e)=>{
        e.preventDefault();
        let table = $('#subscribedLicenceTable').DataTable();
        let data = table.row($(e.target).parents('tr')).data();
        if(data == undefined) {
          let selected_row = $(e.target).parents('tr');
          if (selected_row.hasClass('child')) {
            selected_row = selected_row.prev();
          }
          data = $('#subscribedLicenceTable').DataTable().row(selected_row).data();
        }
        this.validationMsg = "";
        this.subStatusCode = "";
        if(e.target.id == "Content"){
          this.showSubscribedCourseNCertificates(data);
        }else if (e.target.id == "Details"){
          this.couponDetails = data;
          $("#couponDetails").modal("show");
        }
      });

      let avltable = $('#availableLicenceTable').DataTable();
      avltable.destroy();
      $("#availableLicenceTable").DataTable({
        responsive: true,
        "autoWidth" : false,
        "serverSide": true,
        'initComplete': ()=> {
          $("#preloader").css('display','none');

        },
        "ajax": {
          "url": Configuration.ServerWithApiUrl+'/availableLicByUserName/'+this.userID+'/'+this.communityID,
          "type": 'POST',
          "headers" : {
            "Authorization" : currentUser.token.toString()
          },
          "error" : function (xhr, error, thrown) {
            if(xhr.responseJSON && xhr.responseJSON.statusCode) {
              if (xhr.responseJSON.statusCode === 'exp-token' || xhr.responseJSON.statusCode == 'no-token') {
                that.router.navigate(['/login']);
              }
            }
          }
        },
        "language" : {
          url :  currentLang,
          searchPlaceholder : this.availableLicSearchTitle,
          sSearch : ""
        },
        "columns":[
          {"data": "licence_id"},
          {"data": "licence_name"},
          {"data": "term"},
          {"data": "price"},
          {"data": "licence_type"},
          {"data": "created_date"},
          {"data": "licence_id"},
        ],
        "order": [5, 'desc'],
        "columnDefs":[
          {
            "targets": 0,
            "searchable": false,
            "orderable": false,
            "render": function (data) {
              return '<label class="containerDefault">' +
                '<input style="left: 0;" type="checkbox" id="license_id" name="licenceCheckbox" value="'+data+'">'+
                '<span class="checkmarkDefault"></span>'+
                '</label>';
            }
          },
          {
            "targets": 2,
            "render": function (data) {
              if(data.length > 0){
                return data[1]+' '+data[0];
              }else {
                return "NA";
              }
            }
          },{
            "targets": 3,
            "render": function (data) {
              if(data){
                return '$ ' + data;
              } else {
                return "NA";
              }

            }
          },{
            "targets": 5,
            "render": (data)=> {
              if(data == undefined){
                return "NA";
              }else {
                return this.getCreationDate(data);
              }
            }
          },
          {
            "targets": 6,
            "render":  (data) =>{
              if(data == 'global'){
                return '';
              }else if(this.role == "Learner" || this.role == "Manager"){
                return '<div class="demo"  '+ styleTextLeft +'>\n' +
                  '    <div class="wrapper">\n' +
                  '        <div class="content"' + alignContentLeft + '>\n' +
                  '            <ul>\n' +
                  '                <li id="Content">'+this.contentTitle+'</li>\n' +
                  '                <li id="Subscribe">'+this.subscribeTitle+'</li>\n' +
                  '            </ul>\n' +
                  '        </div>\n' +
                  '        <div class="parent"><i class="fa overflow-icon" ></i></div>\n' +
                  '    </div>\n' +
                  '</div>';
              }else {
                return '<div class="demo" '+ styleTextLeft +'>\n' +
                  '    <div class="wrapper">\n' +
                  '        <div class="content"' + alignContentLeft + '>\n' +
                  '            <ul>\n' +
                  '                <li id="Content">'+this.contentTitle+'</li>\n' +
                  '            </ul>\n' +
                  '        </div>\n' +
                  '        <div class="parent"><i class="fa overflow-icon" ></i></div>\n' +
                  '    </div>\n' +
                  '</div>';
              }
            }
          },
          {
            "targets": 4,
            "render": function (data) {
              if(data == "term_License"){
                return "Term";
              } else if(data == "one_time_purchase"){
                return "One Time Purchase";
              } else if(data == "journey_License"){
                return "Journey";
              } else {
                return "Bundle License";
              }
            }
          },
          { 'width': '5%', 'targets': 0 },
          { 'width': '37%', 'targets': 1 },
          { 'width': '13%', 'targets': 2 },
          { 'width': '10%', 'targets': 3 },
          { 'width': '15%', 'targets': 4 },
          { 'width': '10%', 'targets': 5 },
          { 'width': '10%', 'targets': 6 }
        ]
      });
      $('table#availableLicenceTable').on('preXhr.dt', function ( e, settings, data ) {
        data.search.value = data.search.value.trim();
      });
      $('#availableLicenceTable tbody').on('click', 'li', (e)=>{
        let table = $('#availableLicenceTable').DataTable();
        let data = table.row($(e.target).parents('tr')).data();
        this.validationMsg = "";
        this.subStatusCode = "";
        let licence_id = '';
        if(data == undefined) {
          let selected_row = $(e.target).parents('tr');
          if (selected_row.hasClass('child')) {
            selected_row = selected_row.prev();
          }
          data = $('#availableLicenceTable').DataTable().row(selected_row).data();
          if(e.target.id == "Content"){
            this.showCourseNCertificates(data);
          }else if(e.target.id == "Subscribe"){
            this.singleLicense = licence_id;
            this.subscribeSelectedLicense();
          }
        } else {
          licence_id = data.licence_id;
          if(e.target.id == "Content"){
            this.showCourseNCertificates(data);
          }else if(e.target.id == "Subscribe"){
            this.singleLicense = licence_id;
            this.subscribeSelectedLicense();
          }
        }
      });

    }else {
      let table = $('#subscribedLicenceTable').DataTable();
      table.destroy();
      $("#subscribedLicenceTable").DataTable({
        responsive: true,
        "autoWidth" : false,
        'initComplete': ()=> {
          $("#preloader").css('display','none');
          //this.hideSubLictable = false;
        },
        "serverSide": true,
        "ajax": {
          "url": Configuration.ServerWithApiUrl+'/license_subscribedByCommId/'+this.communityID,
          "type": 'POST',
          "headers" : {
            "Authorization" : currentUser.token.toString()
          },
          "error" : function (xhr, error, thrown) {
            if(xhr.responseJSON && xhr.responseJSON.statusCode) {
              if (xhr.responseJSON.statusCode === 'exp-token' || xhr.responseJSON.statusCode == 'no-token') {
                that.router.navigate(['/login']);
              }
            }
          }
        },
        "language" : {
          url :  currentLang,
          searchPlaceholder : this.availableLicSearchTitle,
          sSearch : ""
        },
        "columns":[
          {"data": "licence_name"},
          {"data": "term"},
          {"data":{
            "price": "price",
            "paid_status": "paid_status"
          }},
          {"data": "coupon_code"},
          {"data": "licence_type"},
          {"data": {
            "no_of_license": "no_of_license",
            "no_of_used_license":"no_of_used_license"
          }},
          {"data": "subscribeDate"},
          {"data": "expiry_date"},
          {"data":
            {
              "licence_user_id":"licence_user_id",
              "subscribed_by": "subscribed_by"
            }
          }
        ],
        "order": [6, 'desc'],
        "columnDefs":[
          {
            "targets": 1,
            "render": function (data) {
              if(!data|| data.length== 0){
                return "NA";
              }else {
                return data[1]+' '+data[0];
              }
            }
          },{
            "targets": 2,
            "render": function (data) {
              if(data.paid_status == 'paid'){
                return '$ ' + data.price;
              }else {
                return "NA";
              }
            }
          },{
            "targets": 3,
            "render": function (data) {
              if(data){
                return data;
              }else {
                return "NA";
              }
            }
          },{
            "targets": 5,
            "render": function (data) {
              if(data){
                if((data.no_of_license-data.no_of_used_license) == 0){
                  return data.no_of_license;
                }else {
                  return (data.no_of_license-data.no_of_used_license)+"/"+ data.no_of_license;
                }
              }else {
                return "NA";
              }
            }
          },
          {
            "targets": 6,
            "render": (data)=> {
              if(data){
                return this.getCreationDate(data);
              }else {
                return "NA";
              }
            }
          },{
            "targets": 7,
            "render": (data)=> {
              if(data){
                return this.getCreationDate(data);
              }else {
                return "NA";
              }
            }
          }, {
            "targets": 4,
            "render": function (data) {
              if(data == "term_License"){
                return "Term";
              } else if(data == "one_time_purchase"){
                return "One Time Purchase";
              } else if(data == "journey_License"){
                return "Journey";
              } else {
                return "Bundle";
              }
            }
          },
          {
            "targets": 8,
            "render":  (data) =>{
              if(data){
                if(data.subscribed_by == 'Admin'){
                  return '<div class="demo" '+ styleTextLeft +'>\n' +
                    '    <div class="wrapper">\n' +
                    '        <div class="content"' + alignContentLeft + '>\n' +
                    '            <ul>\n' +
                    '                <li id="Content">'+this.contentTitle+'</li>\n' +
                    '                <li id="View">'+this.viewTitle+'</li>\n' +
                    '                <li id="Details">'+this.detailsTitle+'</li>\n' +
                    '                <li id="Unsubscribe">'+this.unsubTitle+'</li>\n' +
                    '            </ul>\n' +
                    '        </div>\n' +
                    '        <div class="parent"><i class="fa overflow-icon" ></i></div>\n' +
                    '    </div>\n' +
                    '</div>';
                } else {
                  return '<div class="demo" '+ styleTextLeft +'>\n' +
                    '    <div class="wrapper">\n' +
                    '        <div class="content"' + alignContentLeft + '>\n' +
                    '            <ul>\n' +
                    '                <li id="Content">'+this.contentTitle+'</li>\n' +
                    '                <li id="View">'+this.viewTitle+'</li>\n' +
                    '                <li id="Details">'+this.detailsTitle+'</li>\n' +
                    '            </ul>\n' +
                    '        </div>\n' +
                    '        <div class="parent"><i class="fa overflow-icon" ></i></div>\n' +
                    '    </div>\n' +
                    '</div>';
                }
              }else {
                return '<div class="demo" '+ styleTextLeft +'>\n' +
                  '    <div class="wrapper">\n' +
                  '        <div class="content"' + alignContentLeft + '>\n' +
                  '            <ul>\n' +
                  '                <li id="Content">Contents</li>\n' +
                  '            </ul>\n' +
                  '        </div>\n' +
                  '        <div class="parent"><i class="fa overflow-icon" ></i></div>\n' +
                  '    </div>\n' +
                  '</div>';
              }
            }
          },
          { 'width': '30%', 'targets': 0 },
          { 'width': '10%', 'targets': 1 },
          { 'width': '5%', 'targets': 2 },
          { 'width': '10%', 'targets': 3 },
          { 'width': '10%', 'targets': 4 },
          { 'width': '5%', 'targets': 5 },
          { 'width': '10%', 'targets': 6 },
          { 'width': '10%', 'targets': 7 },
          { 'width': '10%', 'targets': 8 }
        ]
      });
      $('table#subscribedLicenceTable').on('preXhr.dt', function ( e, settings, data ) {
        data.search.value = data.search.value.trim();
      });
      $('#subscribedLicenceTable tbody').on('click', 'li', (e)=>{
        let table = $('#subscribedLicenceTable').DataTable();
        let data = table.row($(e.target).parents('tr')).data();
        this.validationMsg = "";
        this.subStatusCode = "";
        if(data == undefined) {
          let selected_row = $(e.target).parents('tr');
          if (selected_row.hasClass('child')) {
            selected_row = selected_row.prev();
          }
          data = $('#subscribedLicenceTable').DataTable().row(selected_row).data();
        }
        if(e.target.id == "Content"){
          this.showSubscribedCourseNCertificates(data);
        }else if(e.target.id == "View"){
          this.LicenseService.getSubscribedUsers(data.licence_user_id).subscribe(res => {
            if(res.status){
              this.noCourseFound = "";
            }else {
              // this.noCourseFound = res.statusCode;
            }
            this.subscribedUsersList = res.data[0];
            if(this.subscribedUsersList && this.subscribedUsersList.length == 0){
              this.subscribedUsersList = null;
            }
            this.subscribedCommunityList = res.data[1];
            if(this.subscribedCommunityList && this.subscribedCommunityList.length == 0){
              this.subscribedCommunityList = null;
            }
            $("#subscribedUsers").modal('show');
          });
        }else if (e.target.id == "Details"){
          this.couponDetails = data;
          $("#couponDetails").modal("show");
        }else if (e.target.id == "Unsubscribe"){
          this.showUnsubscribeModal(data);
        }
      });

      let avltable = $('#availableLicenceTable').DataTable();
      avltable.destroy();
      $("#availableLicenceTable").DataTable({
        responsive: true,
        "autoWidth" : false,
        "serverSide": true,
        'initComplete': ()=> {
          $("#preloader").css('display','none');

        },
        "ajax": {
          "url": Configuration.ServerWithApiUrl+'/license_by_commID/'+this.communityID,
          "type": 'POST',
          "headers" : {
            "Authorization" : currentUser.token.toString()
          },
          "error" : function (xhr, error, thrown) {
            if(xhr.responseJSON && xhr.responseJSON.statusCode) {
              if (xhr.responseJSON.statusCode === 'exp-token' || xhr.responseJSON.statusCode == 'no-token') {
                that.router.navigate(['/login']);
              }
            }
          }
        },
        "language" : {
          url :  currentLang,
          searchPlaceholder : this.availableLicSearchTitle,
          sSearch : ""
        },
        "columns":[
          {"data": "licence_id"},
          {"data": "licence_name"},
          {"data": "term"},
          {"data": "price"},
          {"data": "licence_type"},
          {"data": "created_date"},
          {"data": "licence_id"},
        ],
        "order": [5, 'desc'],
        "columnDefs":[
          {
            "targets": 0,
            "searchable": false,
            "orderable": false,
            "render": function (data) {
              return '<label class="containerDefault">' +
                '<input style="left: 0;" type="checkbox" id="license_id" name="licenceCheckbox" value="'+data+'">'+
                '<span class="checkmarkDefault"></span>'+
                '</label>';
            }
          },
          {
            "targets": 2,
            "render": function (data) {
              if(data.length > 0){
                return data[1]+' '+data[0];
              }else {
                return "NA";
              }
            }
          },{
            "targets": 3,
            "render": function (data) {
              if(data){
                return '$ ' + data;
              } else {
                return "NA";
              }

            }
          },{
            "targets": 5,
            "render": (data)=> {
              if(data == undefined){
                return "NA";
              }else {
                return this.getCreationDate(data);
              }
            }
          },
          {
            "targets": 6,
            "render":  (data) =>{
              if(data == 'global'){
                return '';
              }else if(this.role == "Learner" || this.role == "Manager"){
                return '<div class="demo" '+ styleTextLeft +'>\n' +
                  '    <div class="wrapper">\n' +
                  '        <div class="content"' + alignContentLeft + '>\n' +
                  '            <ul>\n' +
                  '                <li id="Content">'+this.contentTitle+'</li>\n' +
                  '                <li id="Subscribe">'+this.subscribeTitle+'</li>\n' +
                  '            </ul>\n' +
                  '        </div>\n' +
                  '        <div class="parent"><i class="fa overflow-icon" ></i></div>\n' +
                  '    </div>\n' +
                  '</div>';
              }else {
                return '<div class="demo" '+ styleTextLeft +'>\n' +
                  '    <div class="wrapper">\n' +
                  '        <div class="content"' + alignContentLeft + '>\n' +
                  '            <ul>\n' +
                  '                <li id="Content">'+this.contentTitle+'</li>\n' +
                  '            </ul>\n' +
                  '        </div>\n' +
                  '        <div class="parent"><i class="fa overflow-icon" ></i></div>\n' +
                  '    </div>\n' +
                  '</div>';
              }
            }
          },
          {
            "targets": 4,
            "render": function (data) {
              if(data == "term_License"){
                return "Term";
              } else if(data == "one_time_purchase"){
                return "One Time Purchase";
              } else if(data == "journey_License"){
                return "Journey";
              } else {
                return "Bundle License";
              }
            }
          },
          { 'width': '5%', 'targets': 0 },
          { 'width': '37%', 'targets': 1 },
          { 'width': '13%', 'targets': 2 },
          { 'width': '10%', 'targets': 3 },
          { 'width': '15%', 'targets': 4 },
          { 'width': '10%', 'targets': 5 },
          { 'width': '10%', 'targets': 6 }
        ]
      });
      $('table#availableLicenceTable').on('preXhr.dt', function ( e, settings, data ) {
        data.search.value = data.search.value.trim();
      });
      $('#availableLicenceTable tbody').on('click', 'li', (e)=>{
        let table = $('#availableLicenceTable').DataTable();
        let data = table.row($(e.target).parents('tr')).data();
        this.validationMsg = "";
        this.subStatusCode = "";
        let licence_id = '';
        if(data == undefined) {
          let selected_row = $(e.target).parents('tr');
          if (selected_row.hasClass('child')) {
            selected_row = selected_row.prev();
          }
          data = $('#availableLicenceTable').DataTable().row(selected_row).data();
          if(e.target.id == "Content"){
            this.showCourseNCertificates(data);
          }else if(e.target.id == "Subscribe"){
            this.singleLicense = licence_id;
            this.subscribeSelectedLicense();
          }
        } else {
          licence_id = data.licence_id;
          if(e.target.id == "Content"){
            this.showCourseNCertificates(data);
          }else if(e.target.id == "Subscribe"){
            this.singleLicense = licence_id;
            this.subscribeSelectedLicense();
          }
        }
      });
    }
  }

  getLicensePrice(price, name){
    let no_of_license = 0;
    if(this.subscribedUsersList){
      no_of_license += this.subscribedUsersList.length;
    }
    if(this.subscribedCommunityList){
      no_of_license += parseInt(this.subscribedCommunityList[0].no_of_subLicense);
    }
    if(name == 'community'){
      return (price/no_of_license)*parseInt(this.subscribedCommunityList[0].no_of_subLicense);
    }else if(name == 'user'){
      return price/no_of_license;
    }
  }
  getAllCommunityUsers(){
    this.selectedLicensesList = [];
    if(this.communityID == undefined){
      this.validationMsg = "103";
      this.LicenseService.cleareTable().subscribe(res => {
        const subscribeTable = $('#subscribedLicenceTable').DataTable();
        subscribeTable.destroy();
        $('#subscribedLicenceTable').DataTable({
          responsive: true,
          "autoWidth" : false,
          "searching": false,
          "ordering": false,
          "sorting": false
        });
        const availableTable = $('#availableLicenceTable').DataTable();
        availableTable.destroy();
        $('#availableLicenceTable').DataTable({
          responsive: true,
          "autoWidth" : false,
          "searching": false,
          "ordering": false,
          "sorting": false
        });
      });
    }else {
      this.validationMsg = "";
      this.LicenseService.getCommunityAdmin(this.communityID).subscribe(res =>{

        if(res.success == true){

          const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
          this.role = theUser.user.role;
          if(this.role == "Learner" || this.role == "Manager"){
            const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
            this.userID = theUser.user.userid;
            this.showData();
          }else {
            this.userID = res.data;
            this.showData();
          }
        }else {
          const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
          this.userID = theUser.user.userid;
          this.showData();
        }
      });

    }
  }

  getLicenceType(type){
    if(type == "term_License"){
      return "Term License";
    } else {
      return "One Time Purchase";
    }
  }

  getCreationDate(date){
    if(date == undefined){
      return 'NA';
    }else {
      return moment(date).format("DD MMM YYYY");
    }
  }

  getTerm(term){
    if(term && term != ' '){
      return term;
    }else {
      return 'NA';
    }
  }

  subscribeSelectedLicense(){
    this.subscriptionForm.resetForm();
    this.subscriptionFormL.resetForm();
    localStorage.removeItem('all_subscription_arr');
    this.valArr = [];
    this.TotalPrice = 0;
    this.couponValidationMsg = "";
    this.validationMsg = "";
    this.zeroLicenseCode = "";
    $("#userpaypal-button").empty();
    $("#paypal-button").empty();
    let availableTable = $('#availableLicenceTable').DataTable();
    var ids = [];
    availableTable.rows().nodes().to$().find('input[id="license_id"]:checked').each(function(){
      ids.push(this.value);
    });
    if(ids.length == 0){
      this.selectedLicensesList = this.singleLicense ? [this.singleLicense] : [];
    }else {
      this.selectedLicensesList = ids;
    }

    if(this.communityID != undefined){
      if(this.selectedLicensesList.length > 0){
        this.LicenseService.getLicenseById(this.selectedLicensesList)
          .subscribe(licenses => {
            if(licenses.success){
              this.selectedLicenseData = licenses.data;
              this.calculatePriceForLearner();
              for(var j=0; j<this.selectedLicenseData.length; j++) {
                this.words[j] = 1;
              }

              this.LicenseService.getCommunityByCommunityID(this.communityID).subscribe(res => {
                this.showCouponCode = res.data.config[0].allowed_coupon;
              });
              this.paypalButton();
            }
          });

      } else {
        this.validationMsg = "102";
      }
    }else {
      this.communityMsg = "102"
    }
  }

  paypalButton(){
    this.subStatusCode = '';
    this.paymentBy = this.getRole == "Alignor Admin" ? undefined : "Paypal";
    let theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if(this.valArr.length == 0){
      this.TotalPrice = 0;
      let TotalPrice = 0;
      for(let j=0; j<this.selectedLicenseData.length; j++) {
        TotalPrice = 0;
        let price = this.selectedLicenseData[j].price;
        if(price == undefined){
          price = 0;
        }
        let nooflicense = this.words[j];
        TotalPrice = nooflicense * price;
        this.TotalPrice = this.TotalPrice + TotalPrice;
        let obj = {
          licence_id: this.selectedLicenseData[j].licence_id,
          licence_duration: this.selectedLicenseData[j].duration,
          price: this.getFixedPriceDig(TotalPrice),
          term: this.selectedLicenseData[j].term,
          no_of_license: this.words[j],
          no_of_used_license: this.words[j],
          selected_courses: this.selectedLicenseData[j].selected_courses,
          selected_certificates: this.selectedLicenseData[j].selected_certificates,
          selected_journeys: this.selectedLicenseData[j].selected_journeys,
          user_id: this.userID,
          user_name : theUser.user.username,
          created_by: this.userID,
          created_date: new Date().getTime(),
          coupon_code: '',
          community_id: this.communityID,
          subscribed_by: this.subscribed_by,
          paidStatus: this.selectedLicenseData[j].paid_status,
          original_price: this.getFixedPriceDig(TotalPrice),
          no_of_coupons: 0,
          licence_name : this.selectedLicenseData[j].licence_name
        };
        this.valArr.push(obj);
      }
    }
    let couponData;
    if(this.valArr && this.valArr.length > 0) {
      if (this.appliedCoupons != undefined && this.appliedCoupons != 0) {
        couponData = {
          coupon_id: this.coupon_id,
          no_of_coupon_used: this.appliedCoupons
        };
        localStorage.setItem('saveCoupons', JSON.stringify(couponData));
        /*this.LicenseService.updateUsedCoupos(obj).subscribe(res =>{
         });*/
      }
    }
    let c_data = couponData ? JSON.stringify(couponData) : "";
    let tokenData = {
      user_id: this.userID,
      price: this.getFixedPriceDig(this.TotalPrice),
      url : '',
      subscriptionData : this.valArr,
      user_name : theUser.user.username,
      fullname : theUser.user.fullname,
      couponData : c_data,
      licence_renew : false,
      redirect_URL : '/dashboard/Licences/subscribe',
      optional_params : JSON.stringify(this.valArr)
    };
    if(this.getRole == "Learner" || this.getRole == "Manager"){
      $("#userpaypal-button").empty();
      $('#subscribeModal').modal('show');

      if(this.selectedLicenseData.length == 1){
        this.isOneFreeLicNotSelected = this.selectedLicenseData[0].paid_status == 'free' ? true : false;
      } else {
        this.isOneFreeLicNotSelected = false;
      }
      this.subscriptionFor = 'Learner';
      this.subStatusCode = "";
      if(this.TotalPrice > 0){
        let that = this;
        $("#msgDiv").remove();

        let url="";
        $("#preloader").css('display','block');

        let lic = {
          licenses: this.selectedLicensesList,
          user_id: this.userID
        };
        this.LicenseService.checkSubscribedforRelatedCourse(lic).subscribe(res => {
          if (res.success) {
            if (res.statusCode == 200) {

              localStorage.setItem('selectedCommunityName', JSON.stringify(this.model));


              $("#msgDiv").remove();
              $(".mainDiv").show();
              $("#userexpressCheckoutDiv").show();
              $("#userpaypal-button").empty();

              paypal.Button.render({
                env: Configuration.PayPal_Mode,
                style: {
                  size: 'small',
                  color: 'gold',
                  shape: 'rect',
                  label:'checkout',
                  tagline : false,
                  height: 35
                },

                // Set up the payment:
                // 1. Add a payment callback
                payment: (data, actions) => {
                  // 2. Make a request to your server
                  let fixedPrice = that.getFixedPriceDig(that.TotalPrice);
                  return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/'+ fixedPrice + '?token=' + theUser.token , tokenData)
                    .then(function(res) {
                      // 3. Return res.id from the response

                      return res.id;
                    });
                },
                // Execute the payment:
                // 1. Add an onAuthorize callback
                onAuthorize: (data, actions) => {
                  // 2. Make a request to your server
                  let fixedPrice = that.getFixedPriceDig(that.TotalPrice);
                  return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + fixedPrice + '?token=' + theUser.token, {
                    paymentID: data.paymentID,
                    payerID:   data.payerID,
                  })
                    .then((res) => {
                      // 3. Show the buyer a confirmation message.
                      if(res.statusCode == 200){
                        let AMT = res.data.price;
                        let PNREF = res.data.PNREF;

                        $(".mainDiv").hide();
                        $("#userexpressCheckoutDiv").hide();
                        let div = "<div id='msgDiv' style='text-align: center;'>" +
                          '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                          '<p style="font-family: Helvetica;color:#0072BC;">'+this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_SUCCESS']+'</p>' +
                          '<br>' +
                          '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">'+this.tourTranslateData['SUBSCRIPTION_FORM.AMOUNT_PAID']+'</p>' +
                          '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ '+ AMT +'</p>' +
                          '<br>' +
                          '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">'+this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_ID']+' <span style="font-family: Helvetica;color:#000;">'+ PNREF +'</span></p>' +
                          "</div>";
                        $("#msgDiv").remove();
                        $("#payPalModal").append(div);
                        $('#transactionModal').modal('hide');
                        $('#subscribeModal').modal('hide');
                        this.subStatusCode = '200';
                        $('#successModal').modal('show');
                        this.showData();
                      }
                    });
                }
              }, '#userpaypal-button');
              $("#preloader").css('display','none');
            } else if(res.statusCode == 201){
              this.certificateSubscribe = res.statusCode;
              $("#preloader").css('display','none');
            }
          }
        });

      } else {
        $("#userpaypal-button").empty();
      }
    }
    else if(this.getRole == 'Community Admin'){
      $('#transactionModal').modal('show');
      if(this.TotalPrice > 0){
        let that = this;
        $("#msgDiv").remove();

        let url="";
        $("#preloader").css('display','block');

        let lic = {
          licenses: this.selectedLicensesList,
          user_id: this.userID
        };
        this.LicenseService.checkSubscribedforRelatedCourse(lic).subscribe(res => {
          if (res.success) {
            if (res.statusCode == 200) {
              localStorage.setItem('selectedCommunityName', JSON.stringify(this.model));
              $("#msgDiv").remove();
              $(".mainDiv").show();
              $("#expressCheckoutDiv").show();
              $("#paypal-button").empty();

              paypal.Button.render({
                env: Configuration.PayPal_Mode,
                style: {
                  size: 'small',
                  color: 'gold',
                  shape: 'rect',
                  label:'checkout',
                  tagline : false,
                  height: 35
                },

                // Set up the payment:
                // 1. Add a payment callback
                payment: (data, actions) => {
                  // 2. Make a request to your server
                  let fixedPrice = that.getFixedPriceDig(that.TotalPrice);
                  return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/'+ fixedPrice + '?token=' + theUser.token , tokenData)
                    .then(function(res) {
                      // 3. Return res.id from the response

                      return res.id;
                    });
                },
                // Execute the payment:
                // 1. Add an onAuthorize callback
                onAuthorize: (data, actions) => {
                  // 2. Make a request to your server
                  let fixedPrice = that.getFixedPriceDig(that.TotalPrice);
                  return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + fixedPrice + '?token=' + theUser.token, {
                    paymentID: data.paymentID,
                    payerID:   data.payerID,
                  })
                    .then((res) => {
                      // 3. Show the buyer a confirmation message.
                      if(res.statusCode == 200){
                        let AMT = res.data.price;
                        let PNREF = res.data.PNREF;

                        $(".mainDiv").hide();
                        $("#expressCheckoutDiv").hide();
                        let div = "<div id='msgDiv' style='text-align: center;'>" +
                          '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                          '<p style="font-family: Helvetica;color:#0072BC;">'+this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_SUCCESS']+'</p>' +
                          '<br>' +
                          '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">'+this.tourTranslateData['SUBSCRIPTION_FORM.AMOUNT_PAID']+'</p>' +
                          '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ '+ AMT +'</p>' +
                          '<br>' +
                          '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">'+this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_ID']+' <span style="font-family: Helvetica;color:#000;">'+ PNREF +'</span></p>' +
                          "</div>";
                        $("#msgDiv").remove();
                        $("#payPalModal").append(div);
                        $('#transactionModal').modal('hide');
                        $('#subscribeModal').modal('hide');
                        this.subStatusCode = '200';
                        $('#successModal').modal('show');
                        this.showData();
                      }
                    });
                }
              }, '#paypal-button');
              $("#preloader").css('display','none');
            } else if(res.statusCode == 201){
              this.certificateSubscribe = res.statusCode;
              $("#preloader").css('display','none');
            }
          }
        });

      } else {
        $("#paypal-button").empty();
      }
    } else {
      $("#userpaypal-button").empty();
      $('#transactionModal').modal('show');
    }
  }


  selectedLicences(e){
    this.validationMsg = "";
    this.couponValidationMsg = "";
    if(e.target.checked){
      if(!this.selectedLicensesList.find(x => x === e.target.id)) {
        this.selectedLicensesList.push(e.target.id);
      }
    }else {
      if(this.selectedLicensesList.find(x => x === e.target.id)){
        var index = this.selectedLicensesList.indexOf(e.target.id);
        this.selectedLicensesList.splice(index, 1);
      }
    }
  }

  closeModel(){
    this.subscriptionForm.reset();
    this.subscriptionFormL.reset();
    localStorage.removeItem('all_subscription_arr');
    this.TotalPrice = 0;
    this.subtotal = 0;
    this.words = [];
    this.certificateSubscribe = '';
    this.InvalidCoupon = false;
    this.paymentBy = undefined;
    this.agreement = undefined;
    this.discountPrice = 0;
    this.subscriptionFor = '';
    this.couponValidationMsg = '';
    this.singleLicense = '';
    this.selectedLicensesList = [];
    $('#transactionModal').modal('hide');
    $('#subscribeModal').modal('hide');
    window.location.reload();
  }


  genToeknIdForPayflow(){
    var text = "";
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    for (var i = 0; i < 16; i++){
      text += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    text = "Alignor"+text;
    return text;
  }

  changePaymentMode(flag){
    this.subscriptionFor = flag;
    let theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    /*this.subStatusCode = "";
      this.valArr = [];
      this.TotalPrice = 0;
      let TotalPrice = 0;

      for(let j=0; j<this.selectedLicenseData.length; j++) {
        TotalPrice = 0;
        let price = this.selectedLicenseData[j].price;
        if(price == undefined){
          price = 0;
        }
        let nooflicense = this.words[j];
        TotalPrice = nooflicense * price;
        this.TotalPrice = this.TotalPrice + TotalPrice;
        let obj = {
          licence_id: this.selectedLicenseData[j].licence_id,
          licence_duration: this.selectedLicenseData[j].duration,
          price: TotalPrice,
          term: this.selectedLicenseData[j].term,
          no_of_license: this.words[j],
          no_of_used_license: this.words[j],
          selected_courses: this.selectedLicenseData[j].selected_courses,
          selected_certificates: this.selectedLicenseData[j].selected_certificates,
          user_id: this.userID,
          created_by: this.userID,
          created_date: new Date().getTime(),
          coupon_code: '',
          community_id: this.communityID,
          subscribed_by: this.subscribed_by,
          paidStatus: this.selectedLicenseData[j].paid_status,
          original_price: TotalPrice,
          no_of_coupons: 0,
          licence_name : this.selectedLicenseData[j].licence_name
        };
        this.valArr.push(obj);
      }*/

    if(this.paymentBy == 'Paypal' && this.TotalPrice > 0 && this.zeroLicenseCode != '100'){
      let that = this;
      $("#msgDiv").remove();

      let url="";
      $("#preloader").css('display','block');

      let lic = {
        licenses: this.selectedLicensesList,
        user_id: this.userID
      };
      this.LicenseService.checkSubscribedforRelatedCourse(lic).subscribe(res => {
        if (res.success) {
          if (res.statusCode == 200) {

            localStorage.setItem('selectedCommunityName', JSON.stringify(this.model));
            let couponData;
            if(this.appliedCoupons != undefined && this.appliedCoupons != 0){
              couponData = {
                coupon_id: this.coupon_id,
                no_of_coupon_used: this.appliedCoupons
              };
              localStorage.setItem('saveCoupons', JSON.stringify(couponData));
              /*this.LicenseService.updateUsedCoupos(obj).subscribe(res =>{
               });*/
            }
            let c_data = couponData ? JSON.stringify(couponData) : "";
            let tokenData = {
              user_id: this.userID,
              price: this.TotalPrice,
              url : '',
              subscriptionData : this.valArr,
              user_name : theUser.user.username,
              fullname : theUser.user.fullname,
              couponData : c_data,
              licence_renew : false,
              redirect_URL : '/dashboard/Licences/subscribe',
              optional_params : JSON.stringify(this.valArr)
            };
            $("#msgDiv").remove();
            $(".mainDiv").show();
            $("#expressCheckoutDiv").show();
            $("#paypal-button").empty();

            paypal.Button.render({
              env: Configuration.PayPal_Mode,
              style: {
                size: 'small',
                color: 'gold',
                shape: 'rect',
                label:'checkout',
                tagline : false,
                height: 35
              },

              // Set up the payment:
              // 1. Add a payment callback
              payment: (data, actions) => {
                // 2. Make a request to your server
                let fixedPrice = that.getFixedPriceDig(that.TotalPrice);
                return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/'+ fixedPrice + '?token=' + theUser.token , tokenData)
                  .then(function(res) {
                    // 3. Return res.id from the response

                    return res.id;
                  });
              },
              // Execute the payment:
              // 1. Add an onAuthorize callback
              onAuthorize: (data, actions) => {
                // 2. Make a request to your server
                let fixedPrice = that.getFixedPriceDig(that.TotalPrice);
                return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + fixedPrice + '?token=' + theUser.token, {
                  paymentID: data.paymentID,
                  payerID:   data.payerID,
                })
                  .then((res) => {
                    // 3. Show the buyer a confirmation message.
                    if(flag == 'Admin'){
                      $('#transactionModal').modal('hide');
                    } else if(flag == 'Learner' || flag == 'Manager'){
                      $('#subscribeModal').modal('hide');
                    }
                    if(res.statusCode == 200){
                      let AMT = res.data.price;
                      let PNREF = res.data.PNREF;

                      $(".mainDiv").hide();
                      $("#expressCheckoutDiv").hide();
                      let div = "<div id='msgDiv' style='text-align: center;'>" +
                        '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                        '<p style="font-family: Helvetica;color:#0072BC;">'+this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_SUCCESS']+'</p>' +
                        '<br>' +
                        '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">'+this.tourTranslateData['SUBSCRIPTION_FORM.AMOUNT_PAID']+'</p>' +
                        '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ '+ AMT +'</p>' +
                        '<br>' +
                        '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">'+this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_ID']+' <span style="font-family: Helvetica;color:#000;">'+ PNREF +'</span></p>' +
                        "</div>";
                      $("#msgDiv").remove();
                      $("#payPalModal").append(div);
                      $('#transactionModal').modal('hide');
                      $('#subscribeModal').modal('hide');
                      this.subStatusCode = '200';
                      $('#successModal').modal('show');
                    }
                  });
              }
            }, '#paypal-button');
            $("#preloader").css('display','none');
          } else if(res.statusCode == 201){
            this.certificateSubscribe = res.statusCode;
            $("#preloader").css('display','none');
          }
        }
      });

    } else {
      $("#paypal-button").empty();
    }
  }

  subscribeLicense(subscriptionForm, flag){
    // this.agreement = undefined;
    this.subscriptionFor = flag;
    let theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    this.subscriptionForm = subscriptionForm;
    this.subStatusCode = "";
    if(this.valArr.length == 0){
      this.valArr = [];
      this.TotalPrice = 0;
      let TotalPrice = 0;

      for(let j=0; j<this.selectedLicenseData.length; j++) {
        TotalPrice = 0;
        let price = this.selectedLicenseData[j].price;
        if(price == undefined){
          price = 0;
        }
        let nooflicense = this.words[j];
        TotalPrice = nooflicense * price;
        this.TotalPrice = this.TotalPrice + TotalPrice;
        let obj = {
          licence_id: this.selectedLicenseData[j].licence_id,
          licence_duration: this.selectedLicenseData[j].duration,
          price: this.getFixedPriceDig(TotalPrice),
          term: this.selectedLicenseData[j].term,
          no_of_license: this.words[j],
          no_of_used_license: this.words[j],
          selected_courses: this.selectedLicenseData[j].selected_courses,
          selected_certificates: this.selectedLicenseData[j].selected_certificates,
          selected_journeys: this.selectedLicenseData[j].selected_journeys,
          user_id: this.userID,
          user_name : theUser.user.username,
          created_by: this.userID,
          created_date: new Date().getTime(),
          coupon_code: '',
          community_id: this.communityID,
          subscribed_by: this.subscribed_by,
          paidStatus: this.selectedLicenseData[j].paid_status,
          original_price: this.getFixedPriceDig(TotalPrice),
          no_of_coupons: 0,
          licence_name : this.selectedLicenseData[j].licence_name
        };
        this.valArr.push(obj);
      }
    }
    if(this.valArr && this.valArr.length > 0){
      let couponData;
      if(this.appliedCoupons != undefined && this.appliedCoupons != 0){
        couponData = {
          coupon_id: this.coupon_id,
          no_of_coupon_used: this.appliedCoupons
        };
        localStorage.setItem('saveCoupons', JSON.stringify(couponData));
        /*this.LicenseService.updateUsedCoupos(obj).subscribe(res =>{
        });*/
      }

      if(this.paymentBy == 'Paypal' && this.TotalPrice > 0){
        let that = this;
        $("#msgDiv").remove();

        let url="";
        $("#preloader").css('display','block');

        let lic = {
          licenses: this.selectedLicensesList,
          user_id: this.userID
        };
        this.LicenseService.checkSubscribedforRelatedCourse(lic).subscribe(res => {
          if (res.success) {
            if (res.statusCode == 200) {

              localStorage.setItem('selectedCommunityName', JSON.stringify(this.model));

              let c_data = couponData ? JSON.stringify(couponData) : "";
              let tokenData = {
                user_id: this.userID,
                price: this.getFixedPriceDig(this.TotalPrice),
                url : '',
                subscriptionData : this.valArr,
                user_name : theUser.user.username,
                fullname : theUser.user.fullname,
                couponData : c_data,
                licence_renew : false,
                redirect_URL : '/dashboard/Licences/subscribe',
                optional_params : JSON.stringify(this.valArr)
              };
              $("#msgDiv").remove();
              $(".mainDiv").show();
              $("#expressCheckoutDiv").show();
              // $("#paypal-button").empty();

              paypal.Button.render({
                env: Configuration.PayPal_Mode,
                style: {
                  size: 'small',
                  color: 'gold',
                  shape: 'rect',
                  label:'checkout',
                  tagline : false,
                  height: 35
                },

                // Set up the payment:
                // 1. Add a payment callback
                payment: function(data, actions) {
                  // 2. Make a request to your server
                  let fixedPrice = that.getFixedPriceDig(that.TotalPrice);
                  return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/'+ fixedPrice + '?token=' + theUser.token , tokenData)
                    .then(function(res) {
                      // 3. Return res.id from the response

                      return res.id;
                    });
                },
                // Execute the payment:
                // 1. Add an onAuthorize callback
                onAuthorize: (data, actions) =>{
                  // 2. Make a request to your server
                  let fixedPrice = that.getFixedPriceDig(that.TotalPrice);
                  return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + fixedPrice + '?token=' + theUser.token, {
                    paymentID: data.paymentID,
                    payerID:   data.payerID,
                  })
                    .then((res) =>{
                      // 3. Show the buyer a confirmation message.

                      if(res.statusCode == 200){
                        let AMT = res.data.price;
                        let PNREF = res.data.PNREF;

                        $(".mainDiv").hide();
                        $("#expressCheckoutDiv").hide();
                        let div = "<div id='msgDiv' style='text-align: center;'>" +
                          '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                          '<p style="font-family: Helvetica;color:#0072BC;">'+this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_SUCCESS']+'</p>' +
                          '<br>' +
                          '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">'+this.tourTranslateData['SUBSCRIPTION_FORM.AMOUNT_PAID']+'</p>' +
                          '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ '+ AMT +'</p>' +
                          '<br>' +
                          '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">'+this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_ID']+' <span style="font-family: Helvetica;color:#000;">'+ PNREF +'</span></p>' +
                          "</div>";
                        $("#msgDiv").remove();
                        $("#payPalModal").append(div);
                        $('#transactionModal').modal('hide');
                        $('#subscribeModal').modal('hide');
                        this.subStatusCode = '200';
                        $('#successModal').modal('show');
                      }
                    });
                }
              }, '#paypal-button');
              $("#preloader").css('display','none');
            } else if(res.statusCode == 201){
              this.certificateSubscribe = res.statusCode;
              $("#preloader").css('display','none');
            }
          }
        });

      }
      else {
        let license = {
          licenses: this.selectedLicensesList,
          user_id: this.userID
        };

        this.LicenseService.checkSubscribedforRelatedCourse(license).subscribe(res => {
          if(res.success){
            if(res.statusCode == 200){
              if(flag == 'Admin'){
                $('#transactionModal').modal('hide');
                $('#reTypePasswordModel').modal('show');
              } else if(flag == 'Learner' || flag == 'Manager'){
                this.LicenseService.saveLicenseForUser(this.valArr).subscribe( res => {
                  this.subscribeLicIdList =  res.data;
                  this.subStatusCode = res.statusCode;
                  this.valArr = [];
                  if(res.success){
                    var coupons = JSON.parse(localStorage.getItem('saveCoupons'));
                    if(coupons != null){
                      this.LicenseService.updateUsedCoupos(coupons).subscribe(res =>{
                        localStorage.removeItem('saveCoupons');
                      });
                    }
                    this.showData();
                    this.subscriptionForm.reset();
                    this.subscriptionFormL.reset();
                    $('#subscribeModal').modal('hide');
                    $('#successModal').modal('show');
                    this.selectedLicensesList = [];
                  }
                });
              }
              this.certificateSubscribe = '';
            }else if(res.statusCode == 201){
              this.certificateSubscribe = res.statusCode;
              $("#preloader").css('display','none');
            }
          }
        });
      }
    }else{

    }
  }

  calcPrice(){
    this.subtotal = 0;
    for(var j=0; j<this.selectedLicenseData.length; j++) {
      let price = this.selectedLicenseData[j].price;
      if(price == undefined){
        price = 0;
      }
      const license = this.words[j];
      let currPrice = 0;
      if(license == undefined || license == null){
        this.words[j] = 1;
        currPrice = price;
      }else {
        currPrice =  (price* license)
      }
      this.subtotal = this.subtotal + currPrice;
    }
    this.TotalPrice = this.subtotal;
  }

  calculatePriceForLearner(){
    this.subtotal = 0;
    for(var j=0; j<this.selectedLicenseData.length; j++) {
      let price = this.selectedLicenseData[j].price;
      if(price == undefined){
        price = 0;
      }
      const license = 1;
      let currPrice = 0;
      currPrice =  (price* license);
      this.subtotal = this.subtotal + currPrice;
    }
    this.TotalPrice = this.subtotal;
  }

  applyCoupon(){
    $("#userpaypal-button").empty();
    $("#paypal-button").empty();
    this.valArr = [];
    let obj;
    const communityId = this.communityID;//theUser.user.community_id;
    let TotalPrice = 0;
    this.TotalPrice = 0;
    let availableCoupons = 0;
    let usedCoupons = 0;
    this.discountPrice = 0;
    let ttPrice = 0;

    if(this.coupon_code == undefined || this.coupon_code == ''){
      this.couponValidationMsg = "103";
      this.InvalidCoupon = true;
      this.discountPrice = 0;
      for(let j=0; j<this.selectedLicenseData.length; j++) {
        TotalPrice = 0;
        let price = this.selectedLicenseData[j].price;
        if(price == undefined){
          price = 0;

        }

        let nooflicense = this.words[j];
        TotalPrice = nooflicense * price;
        this.TotalPrice = this.TotalPrice + TotalPrice;
        if(this.TotalPrice < 0){
          this.TotalPrice = 0;
        }

        if(TotalPrice < 0){
          TotalPrice = 0;
        }


        obj = {
          licence_id: this.selectedLicenseData[j].licence_id,
          licence_duration: this.selectedLicenseData[j].duration,
          price: TotalPrice,
          term: this.selectedLicenseData[j].term,
          no_of_license: this.words[j],
          no_of_used_license: this.words[j],
          selected_courses: this.selectedLicenseData[j].selected_courses,
          selected_certificates: this.selectedLicenseData[j].selected_certificates,
          selected_journeys: this.selectedLicenseData[j].selected_journeys,
          user_id: this.userID,
          created_by: this.userID,
          created_date: new Date().getTime(),
          coupon_code: '',
          community_id: this.communityID,
          subscribed_by: this.subscribed_by,
          paidStatus: this.selectedLicenseData[j].paid_status,
          original_price: TotalPrice,
          no_of_coupons: 0
        };
        this.valArr.push(obj);
      }
    }else if(this.subtotal == 0){
      this.couponValidationMsg = "";
      this.InvalidCoupon = false;
      this.discountPrice = 0;
      for(let j=0; j<this.selectedLicenseData.length; j++) {
        TotalPrice = 0;
        let price = this.selectedLicenseData[j].price;
        if(price == undefined){
          price = 0;

        }


        let nooflicense = this.words[j];
        TotalPrice = nooflicense * price;
        this.TotalPrice = this.TotalPrice + TotalPrice;
        if(this.TotalPrice<0){
          this.TotalPrice = 0;
        }

        if(TotalPrice < 0){
          TotalPrice = 0;
        }

        obj = {
          licence_id: this.selectedLicenseData[j].licence_id,
          licence_duration: this.selectedLicenseData[j].duration,
          price: TotalPrice,
          term: this.selectedLicenseData[j].term,
          no_of_license: this.words[j],
          no_of_used_license: this.words[j],
          selected_courses: this.selectedLicenseData[j].selected_courses,
          selected_certificates: this.selectedLicenseData[j].selected_certificates,
          selected_journeys: this.selectedLicenseData[j].selected_journeys,
          user_id: this.userID,
          created_by: this.userID,
          created_date: new Date().getTime(),
          coupon_code: '',
          community_id: this.communityID,
          subscribed_by: this.subscribed_by,
          paidStatus: this.selectedLicenseData[j].paid_status,
          original_price: TotalPrice,
          no_of_coupons: 0
        };
        this.valArr.push(obj);
      }
    }else {
      this.InvalidCoupon = false;
      this.appliedCoupons = 0;
      this.LicenseService.getCouponsByCode(this.coupon_code,communityId).subscribe(coupandata =>{
        this.couponValidationMsg = coupandata.statusCode;
        if(coupandata.success == true){
          this.coupon_id = coupandata.data.coupon_id;
          if(coupandata.data.no_of_coupon_used == undefined){
            usedCoupons = 0;
          }else {
            usedCoupons = coupandata.data.no_of_coupon_used;
          }
          if(usedCoupons == coupandata.data.no_of_coupon_ava){
            this.couponValidationMsg = "101";
            this.InvalidCoupon = true;
            this.discountPrice = 0;
            for(var j=0; j<this.selectedLicenseData.length; j++) {
              TotalPrice = 0;
              let price = this.selectedLicenseData[j].price;
              if(price == undefined){
                price = 0;

              }


              let nooflicense = this.words[j];
              TotalPrice = nooflicense * price;
              this.TotalPrice = this.TotalPrice + TotalPrice;
              if(this.TotalPrice<0){
                this.TotalPrice = 0;
              }

              if(TotalPrice < 0){
                TotalPrice = 0;
              }

              obj = {
                licence_id: this.selectedLicenseData[j].licence_id,
                licence_duration: this.selectedLicenseData[j].duration,
                price: TotalPrice,
                term: this.selectedLicenseData[j].term,
                no_of_license: this.words[j],
                no_of_used_license: this.words[j],
                selected_courses: this.selectedLicenseData[j].selected_courses,
                selected_certificates: this.selectedLicenseData[j].selected_certificates,
                selected_journeys: this.selectedLicenseData[j].selected_journeys,
                user_id: this.userID,
                created_by: this.userID,
                created_date: new Date().getTime(),
                coupon_code: '',
                community_id: this.communityID,
                subscribed_by: this.subscribed_by,
                paidStatus: this.selectedLicenseData[j].paid_status,
                original_price: TotalPrice,
                no_of_coupons: 0
              };
              this.valArr.push(obj);
            }
          }else {
            let original_price = 0;
            let no_of_coupons = 0;
            this.appliedCoupons = usedCoupons;
            availableCoupons = coupandata.data.no_of_coupon_ava - usedCoupons;
            let coupon_code = '';
            for(let j=0; j<this.selectedLicenseData.length; j++) {
              TotalPrice = 0;
              original_price = 0;
              no_of_coupons = 0;
              let price = this.selectedLicenseData[j].price;
              if(price == undefined){
                price = 0;

              }

              let nooflicense = this.words[j];
              original_price = price * nooflicense;
              if(this.selectedLicenseData[j].paid_status == 'paid'){
                if(coupandata.data.coupon_type == 'Number Based'){
                  availableCoupons > 0 ? coupon_code = this.coupon_code : coupon_code = '';
                  if(coupandata.data.discount_type == "Price"){
                    for(let i=0;i< nooflicense;i++){
                      if(availableCoupons>0){
                        const total =price- coupandata.data.discount;
                        TotalPrice = TotalPrice + total;
                        availableCoupons--;
                        this.appliedCoupons++;
                        no_of_coupons++;
                      }else {
                        TotalPrice = TotalPrice + price;
                      }
                    }
                  }else if(coupandata.data.discount_type == "Percentage"){
                    for(let i=0;i< nooflicense;i++){
                      if(availableCoupons>0){
                        const total =price- (price * coupandata.data.discount)/100;
                        TotalPrice = TotalPrice + total;
                        availableCoupons--;
                        this.appliedCoupons++;
                        no_of_coupons++;
                      }else {
                        TotalPrice = TotalPrice + price;
                      }
                    }
                  }
                }else if(coupandata.data.coupon_type == 'Time Based') {
                  this.appliedCoupons = undefined;
                  const today = new Date();
                  let currDate = new Date((today.getMonth()+1)+"/"+(today.getDate())+"/"+today.getFullYear()).getTime();
                  if(currDate < coupandata.data.start_date){
                    coupon_code = '';
                    no_of_coupons = 0;
                    this.couponValidationMsg = "202";
                    this.InvalidCoupon = true;
                    TotalPrice = nooflicense * price;
                  }else if(currDate >= coupandata.data.start_date && currDate <= coupandata.data.end_date){
                    coupon_code = this.coupon_code;
                    if(coupandata.data.discount_type == "Price"){
                      for(let i=0;i< nooflicense;i++){
                        const total =price- coupandata.data.discount;
                        TotalPrice = TotalPrice + total;
                        no_of_coupons++;
                      }
                    }else if(coupandata.data.discount_type == "Percentage"){
                      for(let i=0;i< nooflicense;i++){
                        const total =price- (price * coupandata.data.discount)/100;
                        TotalPrice = TotalPrice + total;
                        no_of_coupons++;
                      }
                    }
                  }else {
                    coupon_code = '';
                    this.couponValidationMsg = "102";
                    this.InvalidCoupon = true;
                    TotalPrice = nooflicense * price;
                    no_of_coupons = 0;
                  }
                }
              }else {
                TotalPrice = nooflicense * price;
                coupon_code = '';
                no_of_coupons = 0;
              }
              this.TotalPrice = this.TotalPrice + TotalPrice;
              if(this.TotalPrice<0){
                this.TotalPrice = 0;
              }

              if(TotalPrice < 0){
                TotalPrice = 0;
              }

              this.discountPrice = this.discountPrice + (original_price - TotalPrice);

              if(this.discountPrice < 0){
                this.discountPrice = 0;
              }

              obj = {
                licence_id: this.selectedLicenseData[j].licence_id,
                licence_duration: this.selectedLicenseData[j].duration,
                price: TotalPrice,
                term: this.selectedLicenseData[j].term,
                no_of_license: this.words[j],
                no_of_used_license: this.words[j],
                selected_courses: this.selectedLicenseData[j].selected_courses,
                selected_certificates: this.selectedLicenseData[j].selected_certificates,
                selected_journeys: this.selectedLicenseData[j].selected_journeys,
                user_id: this.userID,
                created_by: this.userID,
                created_date: new Date().getTime(),
                coupon_code: coupon_code,
                community_id: this.communityID,
                subscribed_by: this.subscribed_by,
                paidStatus: this.selectedLicenseData[j].paid_status,
                original_price: original_price,
                no_of_coupons: no_of_coupons
              };
              this.valArr.push(obj);
            }
          }
        }else {
          this.couponValidationMsg = coupandata.statusCode;
          this.InvalidCoupon = true;
          this.discountPrice = 0;
          for(let j=0; j<this.selectedLicenseData.length; j++) {
            TotalPrice = 0;
            let price = this.selectedLicenseData[j].price;
            if(price == undefined){
              price = 0;
            }

            let nooflicense = this.words[j];
            TotalPrice = nooflicense * price;
            this.TotalPrice = this.TotalPrice + TotalPrice;
            if(this.TotalPrice < 0){
              this.TotalPrice = 0;
            }
            if(TotalPrice < 0){
              TotalPrice = 0;
            }

            obj = {
              licence_id: this.selectedLicenseData[j].licence_id,
              licence_duration: this.selectedLicenseData[j].duration,
              price: TotalPrice,
              term: this.selectedLicenseData[j].term,
              no_of_license: this.words[j],
              no_of_used_license: this.words[j],
              selected_courses: this.selectedLicenseData[j].selected_courses,
              selected_certificates: this.selectedLicenseData[j].selected_certificates,
              selected_journeys: this.selectedLicenseData[j].selected_journeys,
              user_id: this.userID,
              created_by: this.userID,
              created_date: new Date().getTime(),
              coupon_code: '',
              community_id: this.communityID,
              subscribed_by: this.subscribed_by,
              paidStatus: this.selectedLicenseData[j].paid_status,
              original_price: TotalPrice,
              no_of_coupons: 0
            };
            this.valArr.push(obj);
          }
        }
        if(this.TotalPrice == 0){
          $("#userpaypal-button").empty();
          $("#paypal-button").empty();
        } else {
          this.paypalButton();
        }
      });
    }
  }

  checkCouponCode(){
    this.couponValidationMsg = "";
    this.discountPrice = 0;
    if(this.coupon_code == ''){
      $("#userpaypal-button").empty();
      $("#paypal-button").empty();
      this.valArr = [];
      this.TotalPrice = 0;
      this.appliedCoupons = 0;
      let TotalPrice = 0;
      for(let j=0; j<this.selectedLicenseData.length; j++) {
        TotalPrice = 0;
        let price = this.selectedLicenseData[j].price;
        if(price == undefined){
          price = 0;
        }
        let nooflicense = this.words[j];
        TotalPrice= nooflicense * price;
        this.TotalPrice = this.TotalPrice + TotalPrice;
        if(this.TotalPrice<0){
          this.TotalPrice = 0;
        }
        let obj = {
          licence_id: this.selectedLicenseData[j].licence_id,
          licence_duration: this.selectedLicenseData[j].duration,
          price: TotalPrice,
          term: this.selectedLicenseData[j].term,
          no_of_license: this.words[j],
          no_of_used_license: this.words[j],
          selected_courses: this.selectedLicenseData[j].selected_courses,
          selected_certificates: this.selectedLicenseData[j].selected_certificates,
          selected_journeys: this.selectedLicenseData[j].selected_journeys,
          user_id: this.userID,
          created_by: this.userID,
          created_date: new Date().getTime(),
          coupon_code: '',
          community_id: this.communityID,
          subscribed_by: this.subscribed_by,
          paidStatus: this.selectedLicenseData[j].paid_status,
          original_price: TotalPrice,
          no_of_coupons: 0
        };
        this.valArr.push(obj);
      }

      if(this.TotalPrice > 0){
        this.paypalButton();
      } else {
        $("#userpaypal-button").empty();
        $("#paypal-button").empty();
      }
    }
  }

  showCourseNCertificates(data){
    $('#coursencertificate').modal('show');
    this.LicenseService.getCourseNCerficate(data.licence_id).subscribe(res =>{
      if(res.success){
        if(res.data[0].length != 0){
          this.courseList = res.data[0];
          this.noCourseFound = "";
        }else {
          this.courseList = res.data[0];
          this.noCourseFound = "210";
        }
        if(res.data[1].length != 0){
          this.certificatesList = res.data[1];
          this.noCertificatesFound = "";
        }else {
          this.certificatesList = res.data[1];
          this.noCertificatesFound = "211";
        }
        if(res.data[2].length != 0){
          this.journeysList = res.data[2];
          this.noJourneysFound = "";
        }else {
          this.journeysList = res.data[2];
          this.noJourneysFound = "211";
        }
      }
    });
  }

  showSubscribedCourseNCertificates(data){
    $('#coursencertificate').modal('show');
    this.LicenseService.getSubscribedCourseAndLicense(data.licence_user_id).subscribe(res =>{
      if(res.success){
        if(res.data[0].length != 0){
          this.courseList = res.data[0];
          this.noCourseFound = "";
        }else {
          this.courseList = res.data[0];
          this.noCourseFound = "210";
        }
        if(res.data[1].length != 0){
          this.certificatesList = res.data[1];
          this.noCertificatesFound = "";
        }else {
          this.certificatesList = res.data[1];
          this.noCertificatesFound = "211";
        }
        if(res.data[2].length != 0){
          this.journeysList = res.data[2];
          this.noJourneysFound = "";
        }else {
          this.journeysList = res.data[2];
          this.noJourneysFound = "211";
        }
      }
    });
  }

  checkLicenseNumber(value){
    let checkZero = false;
    for(let i=0; i< this.words.length;i++)
    {
      if(!this.words[i] || this.words[i] == 0){
        checkZero = true;
      }
    }
    // Calculate current license total
    this.calcPrice();
    // check if license value is zero
    if(checkZero == true){
      this.zeroLicenseCode = "100";
      $("#userpaypal-button").empty();
      $("#paypal-button").empty();
    }else {
      this.zeroLicenseCode = "";
      this.valArr = [];
      this.paypalButton();
    }
  }
  checkPassword(reTypePasswordForm){
    const theCommunity = JSON.parse(localStorage.getItem('currentUser'));
    const user_id = theCommunity.user.userid;
    const Obj = {
      password : this.password,
      user_id : user_id
    };
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(Obj), '#Alignor Credentials#').toString();
    let authentication = {
      authentication: ciphertext
    };
    this.LicenseService.checkPassword(authentication)
      .subscribe(user =>{
        this.tDeleteStatusCode = user.statusCode;
        if(user.success){
          reTypePasswordForm.reset();
          this.LicenseService.saveLicenseForUser(this.valArr).subscribe( res => {
            this.subscribeLicIdList =  res.data;
            this.subStatusCode = res.statusCode;
            this.valArr = [];
            if(res.success){
              var coupons = JSON.parse(localStorage.getItem('saveCoupons'));
              if(coupons != null){
                this.LicenseService.updateUsedCoupos(coupons).subscribe(res =>{
                  localStorage.removeItem('saveCoupons');
                });
              }
              $('#reTypePasswordModel').modal('hide');
              $('#successModal').modal('show');
              this.selectedLicensesList = [];
              this.subscriptionForm.reset();
              this.subscriptionFormL.reset();
            }
          });
        } else {
          this.tDeleteStatusCode = user.statusCode;
        }
      });

  }

  closeModal(reTypePasswordForm){
    reTypePasswordForm.reset();
    this.tDeleteStatusCode = "";
    this.password = "";
    this.valArr = [];
    this.TotalPrice = 0;
    if(this.subscriptionFor == 'Admin'){
      $('#transactionModal').modal('show');
    } else if(this.subscriptionFor == 'Learner' || this.subscriptionFor == 'Manager'){
      $('#subscribeModal').modal('show');
    }
    $('#reTypePasswordModel').modal('hide');
  }

  confirmpasswordFieldReset(){
    this.tDeleteStatusCode = "";
  }

  tabChangeEvent(e){
    if(e.target.id == 'subLic'){
      this.hideSubLictable = false;
      this.hideAvlLictable = true;
      $('.commontab').removeClass('active');
      $('#subLic').addClass('active');
    }else if(e.target.id  == 'availLic'){
      this.hideSubLictable = true;
      this.hideAvlLictable = false;
      $('.commontab').removeClass('active');
      $('#availLic').addClass('active');
    }
    this.LicenseService.cleareTable().subscribe(res => {
      this.showData();
    });
  }
  communityChange(){
    if(this.model == ""){
      this.hideTabs = false;
      this.communityID = undefined;
      this.communityMsg = "";
    }
  }


  closePayflowModel(){
    this.subscriptionForm.reset();
    this.subscriptionFormL.reset();
    localStorage.removeItem('all_subscription_arr');
    this.TotalPrice = 0;
    this.subtotal = 0;
    this.words = [];
    this.certificateSubscribe = '';
    this.InvalidCoupon = false;
    this.paymentBy = undefined;
    this.coupon_id = undefined;
    this.appliedCoupons = 0;
    this.discountPrice = 0;
    this.subscriptionFor = '';
    this.LicenseService.cleareTable().subscribe(res => {
      this.showData();
    });
    $("#msgDiv").remove();
    $("#payflowFrame").empty();
    $("#paypal-button").empty();

  }

  showUnsubscribeModal(data){
    this.licenseUserId = data.licence_user_id;
    this.LicenseService.subscribedUsersByAdmin(data.licence_user_id).subscribe(res => {
      if(res.success){
        this.selectedUserList = res.data;
        $('#unsubscribeModal').modal('show');
      }
    });
  }
  unsubscribeSelectedUsers(){
    var selectedList = [];
    this.validationMsgList = '';
    if(this.selectedUserList.length > 0){
      for(let k=0; k<this.selectedUserList.length; k++){
        if(this.selectedUserList[k].selected == true){
          selectedList.push(this.selectedUserList[k].user_id);
        }
      }
      let obj = {
        users: selectedList,
        licence_user_id: this.licenseUserId
      };
      this.LicenseService.unsubscribeLicense(obj).subscribe( res=> {
        if(res.success){
          this.validationMsgList = res.statusCode;
          $('#successModal').modal('show');
          $('#unsubscribeModal').modal('hide');
          this.showData();
        }
      });
    }
  }
  closeModelSubscribe(selectLicenseItemForm){
    selectLicenseItemForm.reset();
    this.validationMsgList = "";
    $('#unsubscribeModal').modal('hide');
  }

  checkIfAllSelectedLicense() {
    this.validationMsgList = "";
    this.selectedAllUsers = this.selectedUserList.every(function(item:any) {
      return item.selected == true;
    });
  }

  selectAllUsers() {
    this.validationMsgList = "";
    for (var i = 0; i < this.selectedUserList.length; i++) {
      this.selectedUserList[i].selected = this.selectedAllUsers;
    }
  }

  clearSuccessMsg(){
    this.validationMsgList = '';
    this.subStatusCode = '';
    this.validationMsg = '';
    window.location.reload();
  }

  getFixedPriceDig(val){
    let v = parseFloat(val).toFixed(2);
    return v;
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/subscription/subscription.component.ts